import { connect } from 'react-redux'
import withApiError, {
  ERROR_TYPE_REPORTING,
} from 'layers/errorHandling/apiError'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import AdminSingleSiteView from './component'
import { selectors as licenseSelectors } from 'store/licenseManager'
import {
  operations as reportsOperations,
  selectors as reportsSelectors,
} from 'store/reportsManager'
import { TOGGLE_VIEW } from 'store/userSessionManager/constants'
import { LESSON_COMPLETION_SPECIALIZED_UNITS_LABEL } from 'components/AdminSiteHeader/constants'

export const AdminSingleSiteViewContainer = ({
  email,
  fetchLessonCompletionData,
  isFetchingLessons,
  lastUpdatedAt,
  lessonCompletionUnitsLabel,
  programKey,
  shouldFetchLessons,
  showLessonCompletionExport,
  sites,
  sitesPreferences,
  summary,
}) => {
  useEffect(() => {
    if (shouldFetchLessons) {
      fetchLessonCompletionData({ adminEmail: email, program: programKey })
    }
  }, [shouldFetchLessons])

  return (
    <AdminSingleSiteView
      isFetchingLessons={isFetchingLessons}
      lastUpdatedAt={lastUpdatedAt}
      lessonCompletionUnitsLabel={lessonCompletionUnitsLabel}
      showLessonCompletionExport={showLessonCompletionExport}
      sites={sites}
      sitesPreferences={sitesPreferences}
      summary={summary}
    />
  )
}

AdminSingleSiteViewContainer.propTypes = {
  email: PropTypes.string,
  fetchLessonCompletionData: PropTypes.func,
  isFetchingLessons: PropTypes.bool,
  lastUpdatedAt: PropTypes.string,
  lessonCompletionUnitsLabel: PropTypes.string.isRequired,
  programKey: PropTypes.string,
  shouldFetchLessons: PropTypes.bool,
  showLessonCompletionExport: PropTypes.bool,
  sites: PropTypes.array,
  sitesPreferences: PropTypes.object,
  summary: PropTypes.object,
}

const mapDispatchToProps = {
  fetchLessonCompletionData: reportsOperations.fetchLessonCompletionData,
}

export const mapStateToProps = state => {
  const {
    reportsManager: {
      isFetchingAdminLessonCompletionData: isFetchingLessons,
      error,
      selectedProgram: { key: selectedProgramKey },
    },
    userProfileManager: { profile },
  } = state

  const { email } = profile
  const k8ToggleView = state.userSessionManager?.adminDashboard?.k8?.toggleView
  const sites = reportsSelectors.selectSortedAdminLessonCompletionData(state)
  const summary = reportsSelectors.selectAdminLessonCompletionSummaryData(state)

  const sitesPreferences = licenseSelectors.selectActiveAdminSitePreferences(
    state,
  )

  const shouldFetchLessons = !summary && !isFetchingLessons && !error

  const lastUpdatedAt = summary?.etlLastUpdatedAt

  const lessonCompletionUnitsLabel =
    k8ToggleView === TOGGLE_VIEW.SPECIALIZED_UNITS
      ? LESSON_COMPLETION_SPECIALIZED_UNITS_LABEL
      : 'Core Units'

  const showLessonCompletionExport =
    k8ToggleView !== TOGGLE_VIEW.SPECIALIZED_UNITS

  return {
    email,
    isFetchingLessons,
    lastUpdatedAt,
    lessonCompletionUnitsLabel,
    programKey: selectedProgramKey,
    shouldFetchLessons,
    showLessonCompletionExport,
    sites,
    sitesPreferences,
    summary,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withApiError(AdminSingleSiteViewContainer, [ERROR_TYPE_REPORTING]))
